import { contact } from './contact/reducer'
import { feedback } from './feedback/reducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
    contact,
    feedback
})

export default rootReducer


// WEBPACK FOOTER //
// store/reducer.ts